import { logEvent } from 'firebase/analytics'

import { analyticsReady } from '#web-oura-tools/stats/utilities'

export const logModuleEvent = async (appEnv: 'sandbox' | 'staging' | 'release', serviceId: string): Promise<void> => {
  const analytics = await analyticsReady

  if (!analytics) return

  const eventParams = {
    app_env: appEnv,
    service_id: serviceId,
  }

  console.debug('Sending Google Analytics event: page_view', eventParams)

  logEvent(analytics, 'page_view', eventParams)
}
